/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PncTypeModel} from './pnc-type.model';
import {PartNumberChangeTypeBaseModel} from '../../../api/ms-partnumberchanges/contracts/pnc-type/model/part-number-change-type-base.model';
import {PncTypeEnumMapper} from '../pnc-type-enum/pnc-type.enum.mapper';

/**
 * Utility class to map to and from {@link PncTypeModel}
 */
export class PncTypeModelMapper {
    private constructor() {
    }

    static fromPartNumberChangeTypeBaseModelArray(input: PartNumberChangeTypeBaseModel[]): PncTypeModel[] {
        return input?.map((element) => PncTypeModelMapper.fromPartNumberChangeTypeBaseModel(element));
    }

    static fromPartNumberChangeTypeBaseModel(input: PartNumberChangeTypeBaseModel): PncTypeModel {
        const code = PncTypeEnumMapper.fromString(input?.code);

        return {
            code,
            name: input?.name
        };
    }
}
